import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getContainerDetailApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}container/${params.id}`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default getContainerDetailApi